









import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ProgramChain } from "@/data/models/ProgramChain";
import { DryingProgressChartData, extractDryingProgressGraphData } from "@/utils/DryingProgressGraphDataExtractor";
import DryingProgressGraphComponent from "@/components/panel/DryingProgressGraph.vue";
import {
  IresDevice,
  getIresDeviceCategoryFromSerialNumber,
  IresDeviceCategory,
} from "@/data/models/IresDevice";

import {
  IresDeviceSensor,
  IresDeviceSensorValue,
  IresSensorAndValueCombination,
} from "@/data/models/IresDeviceSensor";

@Component({
  components: {
    "drying-progress": DryingProgressGraphComponent,
  },
})
export default class DryingProgressGraphWrapperComponent extends Vue {
  @Prop() programChain!: ProgramChain;
  @Prop() iresDevice!: IresDevice;
  @Prop({ default: null }) forcedEndDate!: Date | null;

  componentActive = false;
  extractedDryingProgressGraphData: DryingProgressChartData | null = null;
  savedZoomAtXPercentage: number | null = null;

  activated() {
    this.componentActive = true;
  }

  deactivated() {
    this.componentActive = false;
  }

  mounted() {
    this.componentActive = true;
  }

  @Watch('programChain')
  onProgramChainChanged(newVal: ProgramChain, oldVal: ProgramChain) {
    if (oldVal === null && newVal !== null) {
      this.computeDryingGraphData();
    }
  }

  async created() {
    this.computeDryingGraphData();
  }

  async computeDryingGraphData() {
    if (!this.programChain?.serialNumber) {
      return null;
    }

    const targetSensors: IresSensorAndValueCombination[] =
      getIresDeviceCategoryFromSerialNumber(this.programChain.serialNumber) ===
      IresDeviceCategory.PANEL
        ? [
            {
              sensor: IresDeviceSensor.PANEL_WALL,
              value: IresDeviceSensorValue.TEMPERATURE,
            },
            {
              sensor: IresDeviceSensor.PANEL_WALL,
              value: IresDeviceSensorValue.INTENSITY,
            },
            {
              sensor: IresDeviceSensor.PANEL_GROUND,
              value: IresDeviceSensorValue.TEMPERATURE,
            },
          ]
        : [
            {
              sensor: IresDeviceSensor.COM_BOX_GUIDE_SENSOR,
              value: IresDeviceSensorValue.TEMPERATURE,
            },
            {
              sensor: IresDeviceSensor.COM_BOX_GUIDE_SENSOR,
              value: IresDeviceSensorValue.RELATIVE_HUMIDITY,
            },
          ];

    this.extractedDryingProgressGraphData = await extractDryingProgressGraphData(
      this,
      this.iresDevice,
      this.programChain.runs,
      targetSensors,
      {
        showDetails: false,
        forcedEndDate: this.forcedEndDate ?? undefined,
        hideRunStartsCausedBeMaxRunDuration: true,
      },
      []
    );
  }

  get dryingProgressChartData() {
    if (!this.componentActive) {
      return null;
    }

    if (!this.programChain) {
      return null;
    }

    const data = this.extractedDryingProgressGraphData;
    
    if (!data) {
      return null;
    }

    return data;
  }

  saveZoomAtXPercentage(value: number) {
    this.savedZoomAtXPercentage = value;
  }
}
